<script>
	// Stores
	import MarketStore from '@/Stores/Sport/MarketStore.js';
	// Components
	import Switch from '@/Components/Switch.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';
	// Constants
	import { Status } from '@/Constants/Market.js';

	export let market;

	let manualResultChecked = market && !market.manual_result;

	function updateManualResult() {
		MarketStore.updateManualResult(market.id, !manualResultChecked)
			.then(() => {
				notify({
					type: 'success',
					title: `${market.name}`,
					message: `Feed Result for Market updated to ${manualResultChecked ? 'On' : 'Off'}`,
					timeout: 3
				});
			})
			.catch(() => {
				manualResultChecked = !manualResultChecked;
				notify({
					type: 'danger',
					title: `${market.name}`,
					message: 'Failed to update Feed Result',
					timeout: 3
				});
			});
	}
</script>

<div class="flex items-center justify-between">
	<div class="text-xs font-semibold uppercase whitespace-nowrap">Feed Result</div>
	<Switch
		on:change={updateManualResult}
		name={`manual-result-${market.id}`}
		bind:checked={manualResultChecked}
		disabled={market.status.id === Status.Resulted}
		small={true}
		className=""
	/>
</div>
